var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";
import "./list-item.css";
var classPrefix = "bbt-react-listitem";
export var ListItem = function (_a) {
  var children = _a.children,
      _b = _a.className,
      className = _b === void 0 ? "" : _b,
      _c = _a.styles,
      styles = _c === void 0 ? {} : _c,
      label = _a.label,
      _d = _a.required,
      required = _d === void 0 ? false : _d;
  return React.createElement("div", {
    className: "".concat(classPrefix, " ").concat(className),
    style: __assign({}, styles)
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-label")
  }, label, required ? React.createElement("span", {
    className: "".concat(classPrefix, "-required")
  }, "*") : null), children);
};